import { ArrowLeft, FileQuestion } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[500px] text-center px-4">
      <FileQuestion className="w-12 h-12 text-gray-300 mb-4" />
      <h1 className="text-2xl font-semibold text-gray-900 mb-2">Page not found</h1>
      <p className="text-sm text-gray-500 mb-6">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Button
        variant="primary"
        onClick={() => navigate('/dashboard')}
        className="flex items-center gap-2 px-4 py-2 text-white rounded-md text-sm font-medium hover: transition-colors"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Dashboard
      </Button>
    </div>
  );
}
